<template lang="pug">
  .b-tabs(:class="{ big, grey, blue }")
    ._item(v-for="tab in tabs" :key="tab.value" @click="$emit('input', tab.value)" :class="{ active: tab.value === value }" )
      span(v-if="tab.label") {{ tab.label }}
      Icon(v-if="tab.icon" :name="tab.icon" pointer)
</template>

<script>
export default {
  name: 'BaseTabs',
  props: {
    tabs: Array,
    value: String,
    big: Boolean,
    grey: Boolean,
    blue: Boolean,
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.tabs {
  height: 30px;
  display: flex;
  overflow: auto;
  letter-spacing: 0.01em;
  font-size: 12px;

  &.big {
    height: 39px;
    font-size: 18px;
  }

  &__item {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 13px;
    height: 100%;
    cursor: pointer;
    color: var(--color-dark-gray);
    background-color: var(--color-super-light);

    &:first-child {
      border-radius: 6px 0 0 6px;
    }

    &:last-child {
      border-radius: 0 6px 6px 0;
    }

    &:hover {
      transition: background-color 0.3s;
      background-color: var(--main-bg);
    }

    svg {
      stroke: var(--color-dark-gray);
    }

    &.active {
      color: var(--main-bg);
      background-color: var(--color-accent);
      stroke: var(--main-bg) !important;
    }
  }

  &.blue &__item {
    svg {
      stroke: transparent;
      fill: var( --color-middle-gray);
    }
    &.active {
      background-color: var(--color-super-light);
      svg {
        fill: var( --color-accent);
        stroke: transparent;
      }
    }
  }

  &.grey &__item {
    color: #8093A7;

    svg {
      stroke: #8093A7;
    }

    &.active {
      color: #fff;
      background-color: #8093A7;

      svg {
        stroke: #fff !important;
      }
    }
  }
}
</style>
